import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import tokenAbi from "../../Connectivity/abi/tokenAbi.json";
import NFTAbi from "../../Connectivity/abi/NFTAbi.json";
import CircularProgress from "@mui/material/CircularProgress";
import {
  buyId,
  masterProcessingIdea,
  conversionRate,
} from "../../../redux/admin/action";
import { useAppKitProvider, useAppKitAccount } from "@reown/appkit/react";
import WalletLoader from "../../../components/common/WalletLoader";
import PagesIndex from "../../PagesIndex";

export default function MasterProcessingFee() {
  const navigate = PagesIndex.useNavigate();
  const location = PagesIndex.useLocation();
  const themeColor = new URLSearchParams(location.search).get("mode");

  const [processingLog, setProcessingLog] = useState();
  const [isVisible, setIsVisible] = useState(true);
  const { walletProvider } = useAppKitProvider("eip155");
  const { id } = PagesIndex.useParams();
  const [pinataUrl, setPinataUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [rateConversion, setRateConversion] = useState(0);
  const { address, isConnected } = useAppKitAccount();

  let MasterPaymentFee = Number(Math.round(5 / rateConversion).toFixed(0));
  async function handleApprove() {
    setLoading(true);
    const provider = new ethers.providers.Web3Provider(walletProvider);
    const signer = provider.getSigner();
    const balance = await signer.getBalance();
    const gasPrice = await provider.getGasPrice();
    let gasCost;
    const tokenContract = new ethers.Contract(
      "0x911E641E0e576F358b8b62578E8d7ce48979d173",
      tokenAbi,
      signer
    );
    const nftcontract = new ethers.Contract(
      "0xaAcaA93ebeb434d8A9E0363623f677A92F735c81",
      NFTAbi,
      signer
    );

    try {
      if (Number(balance.toString()) === 0) {
        setProcessingLog("You have insufficient MATIC balance in your wallet");
        setLoading(false);
        return;
      } else {
        setProcessingLog("");
      }
      setProcessingLog("approving the transaction...");
      let fees2 = ethers.utils.parseEther(MasterPaymentFee.toString());

      const tokenBalance = await tokenContract.balanceOf(address);
      if (Number(tokenBalance.toString()) < Number(fees2.toString())) {
        alert(`You have insufficient token balance`);
        setProcessingLog("You have insufficient token balance");
        setLoading(false);
        return;
      }

      const approveEstimatedGasLimit = await tokenContract.estimateGas.approve(
        "0xaAcaA93ebeb434d8A9E0363623f677A92F735c81",
        fees2
      );
      gasCost = gasPrice.mul(approveEstimatedGasLimit);
      if (balance.lt(gasCost)) {
        setProcessingLog(
          "You have insufficient gas fees for approve transaction"
        );
        setLoading(false);
        return;
      }

      const tx = await tokenContract.approve(
        "0xaAcaA93ebeb434d8A9E0363623f677A92F735c81",
        fees2
      );
      await tx.wait();
      console.log("approved..");
      const evolveEstimatedGasLimit = await nftcontract.estimateGas.evolveIdea(
        pinataUrl,
        MasterPaymentFee.toString()
      );
      gasCost = gasPrice.mul(evolveEstimatedGasLimit);

      if (balance.lt(gasCost)) {
        setProcessingLog("You have insufficient gas fees for this transaction");
        setLoading(false);
        return;
      }

      let feesTransfer = await nftcontract.evolveIdea(
        pinataUrl,
        MasterPaymentFee.toString()
      );
      await feesTransfer.wait();
      setProcessingLog("Minting NFT...");
      const receipt = await provider.getTransactionReceipt(feesTransfer.hash);
      // console.log(feesTransfer, "feesTransfer");
      // console.log(receipt, "receiptttt");

      if (receipt.status === 1) {
        if (feesTransfer.hash) {
          let NFTID = await getTokenId(feesTransfer);
          setProcessingLog("Executing smart contract for payment fees...");
          let values = {
            id: id,
            tx_hash: feesTransfer.hash,
            nftSmartContractId: NFTID,
          };
          setProcessingLog("Executing api call...");
          setTimeout(() => {
            masterProcessingIdea(values).then((res) => {
              setProcessingLog("");
              if (res?.status === 201) {
                setLoading(false);
                navigate("/wallet/success");
              } else {
                setLoading(false);
                navigate("/wallet/success");
              }
            });
          }, 1000);
        } else {
          setLoading(false);
          alert("Transaction is not completed. please try again");
        }
      } else {
        setLoading(false);
        alert("Transaction failed");
      }
    } catch (error) {
      setLoading(false);
      alert(error?.message);
      console.log("error?.message", error?.message);
    }
  }
  useEffect(() => {
    getConversionRate();
  }, []);
  const getConversionRate = () => {
    conversionRate().then((res) => {
      console.log("satyamn::::", res);
      setRateConversion(res?.data?.conversionRate);
    });
  };
  // Loader User Effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  const getTokenId = async (feesTransfer) => {
    try {
      const provider = new ethers.providers.Web3Provider(walletProvider);
      const receipt = await provider.getTransactionReceipt(feesTransfer?.hash);
      if (receipt && receipt?.logs) {
        const tokenInterface = new ethers.utils.Interface([
          "event NFTDetails(address indexed ownerAddress, uint256 indexed tokenId, string indexed tokenURI)",
        ]);
        const transferLog = receipt?.logs?.find((log) =>
          log?.topics?.includes(tokenInterface.getEventTopic("NFTDetails"))
        );
        // console.log(await transferLog?.topics[2], "logData");
        let value = await transferLog?.topics[2];
        let tokenId = parseInt(value, 16);
        // console.log("token id get", tokenId);
        return tokenId;
      } else {
        console.log("No logs found in the transaction receipt.", "");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  useEffect(() => {
    let values = { id: id };
    buyId(values).then((res) => {
      setPinataUrl(res?.data?.pinataUrl);
    });
  }, []);

  // 10 Min timer
  const [timeLeft, setTimeLeft] = useState(600); // 600 seconds = 10 minutes
  useEffect(() => {
    if (loading) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer); // Clean up the interval on component unmount
    } else {
      setTimeLeft(600);
    }
  }, [loading]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <>
      <div
        //className="wallet-box"
        className={`${
          themeColor === "dark"
            ? "wallet-box wallet-box-content-dark"
            : "wallet-box wallet-box-content"
        }`}
      >
        <div className="wallet-box-cont">
          <div className="logo-box">
            <img src={PagesIndex.Png.logo2} alt="" />
            <div className="logo-title">EPISAP</div>
          </div>
          <appkit-button />
          <div className="add-word-break">{address}</div>
          <h4 className="wallet-title">
            Idea Minting Fees <br />
            {MasterPaymentFee} SAP
          </h4>
          <div className="wallet-btn-approve">
            <button
              onClick={handleApprove}
              disabled={!isConnected || loading}
              className={`loader-white ${!isConnected ? "disable-color" : ""}`}
            >
              {loading == true ? <CircularProgress size={16} /> : "Approve"}
            </button>
          </div>
          <div className="wallet-subtitle">{processingLog}</div>
          {loading && (
            <div className="payment-timer">
              <p>
                <strong>
                  The payment is still processing. Please don't close the app or
                  turn off your screen. Wait until you get a response from the
                  wallet. If you don't, you might lose your data.
                </strong>
              </p>
              <h3>Countdown Timer</h3>
              <div style={{ fontSize: "1.5rem" }}>{formatTime(timeLeft)}</div>
            </div>
          )}
        </div>
      </div>
      {isVisible && (
        <div className="wallet-loader">
          <WalletLoader />
        </div>
      )}
    </>
  );
}
